export const colorStatus = (value?: string) => {
  switch (value) {
    case 'Pending_payment':
    case 'Pending_courier':
    case 'pending payment':
    case 'Pending Payment':
    case 'pending courier':
    case 'not started yet':
    case 'Pending':
    case 'pending':
    case 'Draft':
      return '#FF585C';
    case 'Open':
    case 'open':
    case 'In_picking':
    case 'Partial_picked':
    case 'in picking':
    case 'In Picking':
    case 'Incoming':
      return '#F8813E';
    case 'Picked':
    case 'picked':
    case 'Packed':
    case 'Ready_to_ship':
    case 'ready to ship':
    case 'Ready to Ship':
    case 'Ready_to_pickup':
    case 'Shipped':
    case 'shipped':
    case 'Fulfilled':
    case 'Delivered':
    case 'delivered':
    case 'Picked_up':
    case 'Invoiced':
    case 'Not_invoiced':
    case 'Invoice_paid':
    case 'Completed':
    case 'completed':
    case 'Paid':
    case 'paid':
    case 'In Progress':
    case 'Active':
    case 'Confirmed':
    case 'Adjusted':
      return '#21BA45';
    case 'Not_picked':
    case 'Not Picked':
    case 'Unpaid':
    case 'unpaid':
    case 'Overdue':
    case 'Write_off':
    case 'Write Off':
    case 'write off':
    case 'Written Off':
    case 'Failed Delivery':
    case 'failed delivery':
      return '#FF585C';
    case 'not shipped':
    case 'Not Shipped':
    case 'Partial_paid':
      return '#F8813E';
    case 'Cancelled':
    case 'cancelled':
    case 'Voided':
    case 'expired':
      return '#a9a9a9';
    case 'Returned':
    case 'return':
    case 'Return':
      return '#ff585d';
    case 'Closed':
      return '#2c913d';
    default:
      return 'green';
  }
};

export const typePage = (value?: string) => {
  if (!value) {
    return '';
  }
  switch (value) {
    case 'adjustment':
    case 'inbound':
    case 'outbound':
    case 'transfer':
      return 'stock';
    case 'bundle':
      return 'bundle';
    case 'sales':
      return 'sales';
    case 'quotation':
      return 'quotation';
    case 'price':
      return 'price';
    default:
      return '';
  }
};

export const priorityColor = (priority: string) => {
  switch (priority) {
    case 'High':
    case 'high':
      return '#FF585C';
    case 'Medium':
    case 'medium':
      return '#F8813E';
    case 'Low':
    case 'low':
      return '#21BA45';
    default:
      return '#FF585C';
  }
};

export const conversationShopLabel = (value?: string) => {
  switch (value) {
    case 'Whatsapp':
      return 'WhatsApp';
    case 'TikTok':
      return 'TikTok Shop';
    case 'Instagram':
      return 'Instagram DM';
    default:
      return value;
  }
};

export const isSalesAgentAccessible = (profileId?: number) => {
  const profileIds = [453, 31720];
  return profileId ? profileIds.includes(profileId) : false;
};
